module.exports = __webpack_public_path__ + "static/media/book12_fantasierijke-maker.d30000b6.png";